// hooks/useCostCodeMap.js
import { useState, useEffect } from "react";
import axios from "axios";

const API = "https://erp-production-72da01c8e651.herokuapp.com/api";

// Module-level cache so multiple components share one fetch per session
let _cache = null;
let _promise = null;

export function useCostCodeMap() {
  const [codeMap, setCodeMap] = useState(_cache || new Map());

  useEffect(() => {
    if (_cache) {
      setCodeMap(_cache);
      return;
    }
    if (!_promise) {
      const token = localStorage.getItem("token");
      _promise = axios
        .get(`${API}/company-profile/cost-codes`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          _cache = new Map(
            (res.data || [])
              .filter((c) => c.active)
              .map((c) => [c.code.trim(), c.name.trim()]),
          );
          return _cache;
        });
    }
    _promise.then(setCodeMap);
  }, []);

  // sectionNumber → "09 29 00 — Gypsum Board" or just the number as fallback
  const resolveName = (num) => codeMap.get((num || "").trim()) || null;
  const resolveLabel = (num) => {
    const name = resolveName(num);
    return name ? `${num} — ${name}` : num || "—";
  };

  return { codeMap, resolveName, resolveLabel };
}

// Call this when the user saves a cost code change so the cache refreshes
export function invalidateCostCodeCache() {
  _cache = null;
  _promise = null;
}
